<div class="main-page-wrapper">
    <div class="header-container">
        <div fxLayout="column" fxLayoutAlign="center center" class="top-container">
            <div style="width: 100%;" fxLayout="column" fxLayoutAlign="center center">
                <app-desktop-banner></app-desktop-banner>
                <div class="teaser-dektop">
                    <app-teaser-top-desktop></app-teaser-top-desktop>
                </div>


                <!-- -------------------------------------------------------------------------------------------------------------- -->

                <!-- Game Categories -->

                <ng-container *ngIf="!isServer">
                    <div class="search-swiper-container"> 
                        <app-swiper-categories-template (categoryClick)="openSearchDialog()" (searchbarVisible)="searchbarVisible($event)"/>
    
                        <div class="search-icon-container" *ngIf="isSearchbarVisible">
                            <button class="search-btn" (click)="openSearchDialog()">
                            <img style="width: 32px; height: 32px; object-fit: cover;" src="assets/playbison/icons/search-icon.svg" alt="close-btn" />
                            </button>
                        </div>
                    </div>
                </ng-container>

                <!-- -------------------------------------------------------------------------------------------------------------- -->

            </div>

            <ng-container *ngIf="!isServer">
                <div class="swiper-container" style="margin-top: none;">
                    <!-- -------------------------------------------------------------------------------------------------------------- -->
    
                    <!-- Game Cards -->
    
                    <ng-container *ngIf="categories">
                        <ng-container *ngFor="let category of categories | slice : 0 : 1">
                            <app-swiper-game-categories-template [category]="category" (gameClick)="onGameClick($event)"/>
                        </ng-container>
                    </ng-container>
        
                    <!-- -------------------------------------------------------------------------------------------------------------- -->
        
                    <!-- Tournaments -->
        
                    <app-home-page-tournament></app-home-page-tournament>

                    <!-- -------------------------------------------------------------------------------------------------------------- -->
        
                    <!-- Reactivation Campaign -->
                     <ng-container *loggedRender>
                         <app-home-page-reactivation *ngIf="isCampaignComp" (isVisible)="CampaignVisibleComp($event)"></app-home-page-reactivation>
                    </ng-container>

                    <!-- Xmas Campaign -->
                    <!-- <app-home-page-xmas></app-home-page-xmas> -->

                    <!-- Game Cards -->
   
                    <div class="swiper-container">
                        <ng-container *ngIf="categories">
                            <ng-container *ngFor="let category of categories | slice : 1 : 3">
                                <app-swiper-game-categories-template [category]="category" (gameClick)="onGameClick($event)"/>
                            </ng-container>
                        </ng-container>
                    </div>

                    <!-- promotions slider -->

                    <app-home-page-promotions></app-home-page-promotions>

                    <!-- -------------------------------------------------------------------------------------------------------------- -->

                    <div class="swiper-container">
                        <ng-container *ngIf="categories">
                            <ng-container *ngFor="let category of categories | slice : 3 : 4">
                                <app-swiper-game-categories-template [category]="category" (gameClick)="onGameClick($event)"/>
                            </ng-container>
                        </ng-container>
                    </div>

                    <app-home-page-account-balance *loggedRender></app-home-page-account-balance>
                    <!-- -------------------------------------------------------------------------------------------------------------- -->
        
                    <!-- Lemon missions (check later) --> 
        
                    <app-home-page-missions></app-home-page-missions> 
        
                    <!-- -------------------------------------------------------------------------------------------------------------- -->
        
                    <!-- Game Cards -->
    
                    <div class="swiper-container">
                        <ng-container *ngIf="categories">
                            <ng-container *ngFor="let category of categories | slice : 4 : 7">
                                <app-swiper-game-categories-template [category]="category" (gameClick)="onGameClick($event)"/>
                            </ng-container>
                        </ng-container>
                    </div>
        
                    <!-- -------------------------------------------------------------------------------------------------------------- -->
        
                    <!-- Top Providers (check later) -->
        
                    <app-desktop-game-operator-short [operators]="operators"></app-desktop-game-operator-short>
        
                    <!-- -------------------------------------------------------------------------------------------------------------- -->
        
                    <!-- Game Cards -->
    
                    <div class="swiper-container">
                        <ng-container *ngIf="categories">
                            <ng-container *ngFor="let category of categories | slice : 7 : categories.length">
                                <app-swiper-game-categories-template [category]="category" (gameClick)="onGameClick($event)"/>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
            <!-- -------------------------------------------------------------------------------------------------------------- -->
            <!-- 
            <app-desktop-category-menu [data]="categories" [showInput]="false"></app-desktop-category-menu> -->

            <ng-container *appShellNoRender>
                <!-- <div class="desktop-game-logo" *ngIf="minimizePage" fxLayoutAlign="start center">
            <img [routerLink]="['/']" routerLinkActive="router-link-active" alt="white-logo" src="assets/logo/logo-casino-white.svg" />
        </div> -->
                <!-- <app-desktop-top-profile-info *loggedRender></app-desktop-top-profile-info> -->
            </ng-container>

            <!-- <app-desktop-game-category-short class="game-category-wrap" [data]="categories | slice : 0  : 1"></app-desktop-game-category-short>
            <app-home-page-tournament></app-home-page-tournament>
            <app-desktop-game-category-short class="game-category-wrap" [data]="categories | slice : 1  : 2"></app-desktop-game-category-short>
            <app-desktop-game-category-short class="game-category-wrap" [data]="categories | slice : 2  : 4"></app-desktop-game-category-short>
            <app-home-page-missions></app-home-page-missions>
            <app-desktop-game-category-short class="game-category-wrap" [data]="categories | slice : 4 : 7"></app-desktop-game-category-short>
            <app-desktop-game-operator-short [operators]="operators"></app-desktop-game-operator-short>
            <app-desktop-game-category-short class="game-category-wrap" [data]="categories | slice : 7"></app-desktop-game-category-short>
            <span fxFlex></span> -->
            <!-- <app-main-auth *appShellNoRender></app-main-auth> -->
        </div>
    </div>
    <app-desktop-expansion-panel [data]="expansionPanel"></app-desktop-expansion-panel>
</div>


<router-outlet></router-outlet>